import { create } from "zustand";
import type { CardView } from "./cardViews";

interface DragState {
  /** The card currently being dragged out of the hand, if any. */
  card: CardView | null;
  /** The specific hand copy being dragged — distinct from `card`, which is only the catalogue view. */
  instanceId: string | null;
  /** Cursor position in screen space, for the floating card ghost. */
  x: number;
  y: number;
  begin: (card: CardView, instanceId: string, x: number, y: number) => void;
  move: (x: number, y: number) => void;
  end: () => void;
}

export const useDragStore = create<DragState>((set) => ({
  card: null,
  instanceId: null,
  x: 0,
  y: 0,
  begin: (card, instanceId, x, y) => set({ card, instanceId, x, y }),
  move: (x, y) => set({ x, y }),
  end: () => set({ card: null, instanceId: null }),
}));
